module.exports = __webpack_public_path__ + "static/media/Slider3.c299ca24.png";